import {FormControl, FormControlLabel, Radio, RadioGroup} from "@material-ui/core";
import {GeneriskAction, GeneriskModel} from "../GeneriskeRapporter/update";
import {Just, Nothing} from "purify-ts/Maybe";
import tw from "twin.macro";
import React from "react";
import {ReportType} from "../../models/ReportType";

interface ReportTypeRadioGroupProps {
  generiskState: GeneriskModel;
  generiskDispatch: React.Dispatch<GeneriskAction>;
}

export default function ReportTypeRadioGroup({
  generiskState,
  generiskDispatch
}: ReportTypeRadioGroupProps) {
  const id = generiskState.selectedReportType.extract()?.id ?? 0;
  const relationalChecked = id === ReportType.RELASJON_EXCEL || id === ReportType.RELASJON_GEOPACKAGE;

  return (
    <FormControl component="fieldset">
      <RadioGroup
        value={generiskState.selectedReportType.extractNullable()?.id ?? 0}
        onChange={event => {
          const selectedReportType = generiskState.reportTypes.find(
            report => report.id === Number(event.target.value)
          );
          generiskDispatch({
            type: "SelectReportType",
            payload: selectedReportType ? Just(selectedReportType) : Nothing,
          });
        }}
      >
        <FormControlLabel
          value={ReportType.VEGNETT}
          style={tw`flex flex-row m-0`}
          control={<Radio color="primary" />}
          label="Vegnettsrapport (V1)"
          labelPlacement="top"
        />
        <FormControlLabel
          value={ReportType.DETALJERT_MENGDEOVERSIKT}
          style={tw`flex flex-row m-0`}
          control={<Radio color="primary" />}
          label="Detaljert mengdeoversikt (V4)"
          labelPlacement="top"
        />
        <FormControlLabel
          value={ReportType.RELASJON_EXCEL}
          checked={relationalChecked}
          style={tw`flex flex-row m-0`}
          control={<Radio color="primary" />}
          label="Relasjonsrapport"
          labelPlacement="top"
        />
        <FormControlLabel
          value={ReportType.OVERLAPP}
          style={tw`flex flex-row m-0`}
          control={<Radio color="primary" />}
          label="Overlappsrapport"
          labelPlacement="top"
        />
        <FormControlLabel
          value={ReportType.TUNNEL_SPEED_REPORT}
          style={tw`flex flex-row m-0`}
          control={<Radio color="primary" />}
          label="Tunnelrapport"
          labelPlacement="top"
        />
        <FormControlLabel
          value={ReportType.OBJECT_HOLE}
          style={tw`flex flex-row m-0`}
          control={<Radio color="primary" />}
          label="Hull i heldekkende objekter"
          labelPlacement="top"
        />
      </RadioGroup>
    </FormControl>
  )
}
